module.exports = __webpack_public_path__ + "img/discord.ff1b60a1.svg";